import React from 'react';
import { howItWorks } from '../data/mock';
import { Card, CardContent } from './ui/card';

const HowItWorks = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-4">
            Simple & Seamless
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Your journey to the perfect holiday in three easy steps
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connection Lines for Desktop */}
          <div className="hidden md:block absolute top-20 left-0 right-0 h-1 bg-gradient-to-r from-[#c9a961]/20 via-[#c9a961] to-[#c9a961]/20 -z-10"></div>

          {howItWorks.map((step, index) => (
            <Card 
              key={step.step}
              className="relative border-none shadow-lg hover:shadow-2xl transition-all duration-500 bg-white animate-fade-in"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <CardContent className="p-8 text-center">
                <div className="w-20 h-20 bg-[#c9a961] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <span className="text-4xl font-bold text-white">{step.step}</span>
                </div>
                <h3 className="text-2xl font-bold text-[#1e3a5f] mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {step.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
